import React, { Component } from 'react'
import { connect } from 'react-redux'
import isEmpty from 'lodash/isEmpty'

import { setFavoritePlant } from '../../actions'

import {
    PlantListItem as ListItem,
    PlantListItemImage,
    PlantListItemContent,
    PlantListItemName,
    PlantListItemLatinName,
    PlantListItemAction
} from '../StyledComponents/Plants/PlantList'

const starIcon = require('../../assets/images/stern-100.png')
const starIconFilled = require('../../assets/images/stern-filled-100.png')
const binIconFilled = require('../../assets/images/minus.png')
const plantDefaultImage = require('../../assets/images/Intro/plant-gray.png')

class PlantListItem extends Component {
    constructor(props) {
        super(props)

        this.setFavorite = this.setFavorite.bind(this)
        this.removeClicked = this.removeClicked.bind(this)
    }

    setFavorite(e) {
        e.preventDefault()

        const {
            plant, setAsFavorite, favoritePlants, sessionState,
        } = this.props

        if (sessionState.authUser.uid && !!sessionState.idToken) {
            setAsFavorite(
                plant.id,
                favoritePlants.favorites[plant.id],
                sessionState.authUser.uid,
                sessionState.idToken.token
            )
        } else {
            // TODO: throw error message and reload page?
        }
    }

    removeClicked(e) {
        e.preventDefault()

        const {
            plant, onPlantRemove,
        } = this.props

        onPlantRemove(plant.id)
    }

    render() {
        const {
            plant, favoritePlants, style, sessionState, showDelete, showPlain,
        } = this.props

        const icon = favoritePlants.favorites[plant.id] ? starIconFilled : starIcon
        const plantImage = isEmpty(plant.image) ? plantDefaultImage : plant.image

        let itemAction = null
        if (showDelete) {
            itemAction = <PlantListItemAction src={binIconFilled} onClick={this.removeClicked} />
        } else if (!showPlain && favoritePlants.isSet) {
            itemAction = <PlantListItemAction src={icon} onClick={this.setFavorite} />
        }

        const actionButton = !!sessionState.authUser && !!sessionState.authUser.emailVerified
            ? itemAction
            : null

        return (
            <ListItem to={`/plants/${plant.id}`} className="row" style={style}>
                <PlantListItemImage
                    objectFit={plantImage === plantDefaultImage ? 'contain' : 'cover'}
                    src={plantImage}
                    className="col-4 col-sm-3 col-lg-2"
                />
                <PlantListItemContent className="col-8">
                    <PlantListItemName showPlain={showPlain || false}>
                        {plant.localized_name}
                    </PlantListItemName>
                    <PlantListItemLatinName showPlain={showPlain || false}>
                        {plant.name}
                    </PlantListItemLatinName>
                    {actionButton}
                </PlantListItemContent>
            </ListItem>
        )
    }
}

const mapStateToProps = state => ({
    favoritePlants: state.favoritePlants,
    sessionState: state.sessionState,
})

export default connect(mapStateToProps, {
    setAsFavorite: setFavoritePlant,
})(PlantListItem)



// WEBPACK FOOTER //
// ./src/components/Plant/PlantListItem.js